import React from 'react';

import * as S from './NoBusFoundStyle';
import { BaseColumnWrap } from './../common/common.styles';
import Icon from './../../../stories/core-components/IconsSelector';
const NoBusFoundUI = (props) => {
    const {searchedDateHeading,searchedDateMsg} = props;
    return (
        <S.NoBusFound>
            <div className="imgWrap">
                <Icon
                name="NoBusIcon"
                styleProps={{fill: 'white'}}
              />
            </div>
            <BaseColumnWrap>
    <p className="noBusFoundHeading">{`No buses found for ${searchedDateHeading}`}</p>
                <p>{`We could not find any direct bus for your selected date.`}</p>
                <p>Explore other options below.</p>
            </BaseColumnWrap>
        </S.NoBusFound>
    );
};

export default NoBusFoundUI;
//04 Nov .. Nov 4